export class ModalInformationDTO{
    title: string;
    message: string;
    icon?: string;
}